import React, { useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import TitleBar from "../../partials/content/TitleBar";
import ButtonDisable from "../../partials/other/ButtonDisable";
import StepsAddCampaigns from "./StepsAddCampaigns";
import helperNumbers from "../../../helpers/numbers";
import helpersTime from "../../../helpers/time";
import ListCategoryUserSitePublisher from "../publisher/ListCategoryUserSitePublisher";

export default function AddCampaign() {
  let items = [
    {
      title: "نوع کمپین",
      status: true,
      link: "/campaigns/all-type",
    },
    {
      title: "نوع کمپین بنری",
      status: true,
      link: "/campaigns/all-type-banner",
    },
    {
      title: "گروه نمایش دهنده بنری",
      status: true,
      link: "/campaigns/banner/simple/add-group-site-publisher",
    },
    {
      title: "کمپین بنری",
      status: true,
      link: "/campaigns/banner/simple/add",
    },
    {
      title: "تبلیغ بنری",
      status: false,
      link: "/campaigns/banner/add-simple",
    },
  ];

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [countPosition, setCountPosition] = useState(0);
  const [priceOnDay, setPriceOnDay] = useState(0);
  const [priceEachHour, setPriceEachHour] = useState(0);
  const [countDays, setCountDays] = useState(0);
  const [priceCampaign, setPriceCampaign] = useState(0);
  const [pledge, setPledge] = useState(0);
  const [priceTotal, setPriceTotal] = useState(0);

  const selectCampaign = (e) => {
    e.preventDefault();
    const value = parseInt(e.target.value);
    if (value == 0) {
      return;
    }
    let category = ListCategoryUserSitePublisher.filter(
      (category) => category.id == 6
    );
    category = category[0];
    setStartDate(category.start_date);
    setEndDate(category.end_date);
    setCountDays(category.count_day);
    setCountPosition(category.count_position);
    setPriceOnDay(category.amount);
    setPriceEachHour(Math.floor(category.amount / 24));
    setPriceCampaign(category.amount * category.count_day);
    setPledge(Math.floor((category.amount * category.count_day) / 3));
    setPriceTotal(
      category.amount * category.count_day +
        Math.floor((category.amount * category.count_day) / 3)
    );
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <TitleBar title="اضافه کردن کمپین" />

        <section className="content pt-5">
          <div className="card">
            <div className="card-body">
              <StepsAddCampaigns items={items} />

              <div className="alert alert-warning ">
                <p className="text-justify">
                  <i className="fa fa-info pl-2"></i>
                  توجه داشته باشید :{" "}
                </p>
                <ul className="pr-3">
                  <li>
                    <p className="text-justify">
                      اگر تاریخ شروع گروه نمایش دهنده شما برابر یا قبل از تاریخ
                      امروز باشد در بخش گروه نمایش دهندگان زیر نمایش داده
                      نمیشود.{" "}
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      هر گروه نمایش دهنده فقط میتواند به یک کمپین اختصاص داده
                      شود.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      مبلغ بیعانه ابتدا درج کمپین از موجودی حساب شما کسر خواهد
                      شد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      %۳۳ مبلغ کمپین بابت رزور جایگاه های انتخابی شما به عنوان
                      بیعانه در زمان درج کمپین از موجودی حساب شما کسر میگردد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      مبلغ بیعانه در صورت اتمام زمان کمپین به حساب شما
                      بازگردانده خواهد شد.
                    </p>
                  </li>
                  <li>
                    <p className="text-justify">
                      در صورت کنسل شدن کمپین مبلغ بیعانه به موجودی حساب شما
                      بازگشت داده نخواهد شد.
                    </p>
                  </li>
                </ul>
              </div>

              <div className="container-fluid">
                <div className="row">
                  <div className="col-12 ">
                    <div id="add-campaign-user"></div>
                    <form>
                      <div className="col-12 col-md-6  ">
                        <label>نام کمپین</label>
                        <input
                          className="form-control"
                          id="name-campaign"
                          type="text"
                        />
                      </div>
                      <div className="col-12 col-md-6 py-4 ">
                        <label>گروه سایت های نمایش دهنده بنری</label>
                        <select
                          onChange={selectCampaign}
                          id="category-campaign"
                          className="form-control"
                        >
                          <option value="0">انتخاب کنید</option>
                          <option value="1">گروه بنری روپلاک یاسر ۱۴۰۱</option>
                        </select>
                      </div>
                      <div className="table-responsive ">
                        <table className="table table-hilite tbl-td-white-space ">
                          <thead>
                            <tr>
                              <td
                                colSpan={2}
                                className="text-center"
                                style={{ borderRadius: "25px 25px 0 0" }}
                              >
                                <b>اطلاعات کمپین</b>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>تاریخ شروع</td>
                              <td>
                                <span className="number-finance">
                                  <label className="pr-2">
                                    {startDate &&
                                      helperNumbers.toPersianNum(
                                        helpersTime.convertGregorianToJalali(
                                          startDate
                                        )
                                      )}
                                  </label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>تاریخ پایان</td>
                              <td>
                                <span className="number-finance">
                                  <label className="pr-2">
                                    {endDate &&
                                      helperNumbers.toPersianNum(
                                        helpersTime.convertGregorianToJalali(
                                          endDate
                                        )
                                      )}
                                  </label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>تعداد جایگاه</td>
                              <td>
                                <label>
                                  {" "}
                                  {helperNumbers.toPersianNum(countPosition)}
                                </label>
                              </td>
                            </tr>
                            <tr>
                              <td>مبلغ یک شبانه روز کمپین </td>
                              <td>
                                <span>
                                  <span>
                                    <label
                                      className="letter-spacing-finance-number  
                                 "
                                    >
                                      {helperNumbers.toPersianNum(
                                        helperNumbers.toFormatFinanceNumber(
                                          priceOnDay
                                        )
                                      )}
                                    </label>
                                    <label
                                      className="pr-2
                                 "
                                    >
                                      تومان
                                    </label>
                                  </span>
                                  <span className="pr-2 text-danger d-none ">
                                    <label className="letter-spacing-finance-number ">
                                      ۰
                                    </label>
                                    <label className="pr-2">تومان</label>
                                  </span>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>مبلغی که در هر ساعت کسر میشود</td>
                              <td>
                                <span>
                                  <label
                                    className="letter-spacing-finance-number  
                               "
                                  >
                                    {helperNumbers.toPersianNum(
                                      helperNumbers.toFormatFinanceNumber(
                                        priceEachHour
                                      )
                                    )}
                                  </label>
                                  <label
                                    className="pr-2
                               "
                                  >
                                    {" "}
                                    تومان
                                  </label>
                                </span>
                                <span className="pr-2 text-danger d-none ">
                                  <label className="letter-spacing-finance-number ">
                                    ۰
                                  </label>
                                  <label className="pr-2">تومان</label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>تعداد شبانه روز کمپین</td>
                              <td>
                                <span>
                                  <label>
                                    {helperNumbers.toPersianNum(
                                      helperNumbers.toFormatFinanceNumber(
                                        countDays
                                      )
                                    )}
                                  </label>
                                  <label className="pr-2">شبانه روز</label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>مبلغ کمپین</td>
                              <td>
                                <span>
                                  <label
                                    className="letter-spacing-finance-number  
                                 "
                                  >
                                    {helperNumbers.toPersianNum(
                                      helperNumbers.toFormatFinanceNumber(
                                        priceCampaign
                                      )
                                    )}
                                  </label>
                                  <label
                                    className="pr-2
                                "
                                  >
                                    تومان
                                  </label>
                                </span>
                                <span className="pr-2 text-danger d-none ">
                                  <label className="letter-spacing-finance-number">
                                    ۰
                                  </label>
                                  <label className="pr-2"> تومان</label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>مبلغ بیعانه کمپین </td>
                              <td>
                                <span>
                                  <label
                                    className="letter-spacing-finance-number  
                                "
                                  >
                                    {helperNumbers.toPersianNum(
                                      helperNumbers.toFormatFinanceNumber(
                                        pledge
                                      )
                                    )}
                                  </label>
                                  <label
                                    className="pr-2
                                "
                                  >
                                    {" "}
                                    تومان
                                  </label>
                                </span>
                                <span className="pr-2 text-danger d-none ">
                                  <label className="letter-spacing-finance-number">
                                    ۰
                                  </label>
                                  <label className="pr-2"> تومان</label>
                                </span>
                              </td>
                            </tr>
                            <tr>
                              <td>مبلغ کل کمپین</td>
                              <td>
                                <span>
                                  <label
                                    className="letter-spacing-finance-number  
                                "
                                  >
                                    {helperNumbers.toPersianNum(
                                      helperNumbers.toFormatFinanceNumber(
                                        priceTotal
                                      )
                                    )}
                                  </label>
                                  <label
                                    className="pr-2
                               "
                                  >
                                    {" "}
                                    تومان
                                  </label>
                                </span>
                                <span className="pr-2 text-danger d-none ">
                                  <label className="letter-spacing-finance-number">
                                    ۰
                                  </label>
                                  <label className="pr-2"> تومان</label>
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="col-12 col-md-6 pt-2 ">
                        <div className="input-group mb-3">
                          <input
                            type="text"
                            className="form-control"
                            id="discount-title"
                            disabled=""
                            placeholder="کد تخفیف خود را وارد کنید."
                          />
                          <ButtonDisable
                            buttonTagHtml={
                              <div className="input-group-append">
                                <button
                                  className="btn btn-info rounded opacity-50"
                                  type="button"
                                  disabled=""
                                >
                                  اعمال کد تخفیف
                                </button>
                                <button
                                  className="btn btn-info opacity-50"
                                  disabled=""
                                  type="button"
                                >
                                  <i className="fa fa-times"></i>
                                </button>
                              </div>
                            }
                          ></ButtonDisable>

                          <div className="pt-2 w-100"></div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center pr-2">
                        <span className="d-flex align-items-center pl-2">
                          <input
                            className="hover"
                            disabled=""
                            type="checkbox"
                          />
                        </span>
                        <span>شرایط را می پذیرم</span>
                      </div>
                      <div className="col-12 col-md-6 pt-2 ">
                        <ButtonDisable
                          buttonTagHtml={
                            <span className="btn btn-primary opacity-50">
                              درج کمپین
                            </span>
                          }
                        ></ButtonDisable>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
